import { useState } from "react";
import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import { CardTitle } from "../theme/texts";
import ActivityLabel from "./ActivityLabel";
import { Theme } from "../../data/style/Theme";
import { SpacedRow } from "../../data/style/Style";
import useScreenSize from "../../context/ScreenContext";

const WeeklyActivity = () => {
  const [completion, setCompletion] = useState(0);
  const { mobileDevice } = useScreenSize();
  return (
    <MainCard>
      <CardTitle
        subTitle={"This week"}
        mainTitle={"Activity"}
        isMobile={mobileDevice}
      />
      <ProgressBar completion={completion} />
      <Stack gap={1} height={"100%"} justifyContent={"space-between"}>
        <ActivityLabel
          title={"Random workout"}
          type={1}
          setCompletion={setCompletion}
        />
        <ActivityLabel
          title={"Gymnastics workout"}
          type={2}
          setCompletion={setCompletion}
        />
        <ActivityLabel
          title={"Cardio workout"}
          type={3}
          setCompletion={setCompletion}
        />
        <ActivityLabel
          title={"Weightlifting workout"}
          type={4}
          setCompletion={setCompletion}
        />
        <ActivityLabel
          title={"Dumbell workout"}
          type={5}
          setCompletion={setCompletion}
        />
      </Stack>
    </MainCard>
  );
};

export default WeeklyActivity;

const ProgressBar = ({ completion }) => {
  return (
    <div style={{ marginBottom: 14 }}>
      <SpacedRow mb={1}>
        <span
          style={{
            fontFamily: "DM Sans, sans-serif",
            fontSize: 11,
            color: Theme.palette.muted,
          }}
        >
          {completion / 20}/5 completed
        </span>
        <span
          style={{
            fontFamily: "Oswald, sans-serif",
            fontWeight: 700,
            fontSize: 12,
            color: Theme.palette.orange,
          }}
        >
          {completion}%
        </span>
      </SpacedRow>
      <div
        style={{
          height: 4,
          borderRadius: 99,
          background: Theme.palette.border,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${completion}%`,
            borderRadius: 99,
            background: "linear-gradient(90deg,#f97316,#ea580c)",
            boxShadow: "0 0 8px rgba(249,115,22,.4)",
            transition: "width .8s ease",
          }}
        />
      </div>
    </div>
  );
};
